import React from 'react'
import { Logo } from '../Public/Navbar'
import { NavLink } from 'react-router-dom'

export const navlinks = [
  { name: 'Category', path: 'category' },
  { name: 'Project', path: 'project' },
  { name: 'Contact', path: 'contact' },
  { name: 'Company', path: 'company' },
  { name: 'Team', path: 'team' },
  { name: 'Testimonial', path: 'testimonial' },
]

// {navLinks.map(({ name, path }, index) => (
//   <NavLink
//     to={path}
//     key={index}
//     onClick={onClose}
//     className={({ isActive }) =>
//       isActive
//         ? 'font-nunito text-[24px] font-normal leading-[32.74px]  text-[#8C1D40]'
//         : 'font-nunito text-[24px] font-normal leading-[32.74px] text-[#F5F5F5]'
//     }
//   >
//     {name}
//   </NavLink>
// ))}

function SIdebar() {
  return (
    <div className="hidden min-h-svh w-[240px] flex-col items-center bg-[#333333] p-6 sm:flex">
      <span>{Logo}</span>

      <div className="flex size-full flex-col items-start justify-center gap-5 ">
        {navlinks.map(({ name, path }, index) => (
          <NavLink
            to={path}
            key={index}
            className={({ isActive }) =>
              isActive
                ? 'font-nunito text-[24px] font-normal leading-[32.74px] transition-colors duration-300  text-[#8C1D40]'
                : 'font-nunito text-[24px] font-normal leading-[32.74px] text-[#F5F5F5]'
            }
          >
            {name}
          </NavLink>
        ))}
      </div>
    </div>
  )
}

export default SIdebar
